'use client'

import { Check, Copy } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'

export function AnimatedCopyIcon({
  copied,
  className,
}: {
  copied: boolean
  className: string
}) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.span
        key={copied ? 'check' : 'copy'}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.08 }}
        className="flex items-center justify-center"
      >
        {copied ? (
          <Check className={`${className} text-emerald-500`} />
        ) : (
          <Copy className={`${className} text-muted-foreground`} />
        )}
      </motion.span>
    </AnimatePresence>
  )
}
